import _ from 'underscore';
import urlTemplate from './url-template.pug';

export function getTemplateWithUrlFromModel(i18n, model) {
  return options => (
    urlTemplate(_.extend({
      isCustomerLevel: model.isCustomerLevel,
      trackingTemplateValue: model.TrackingTemplateValue || i18n.get('Import_ImportOptions_TrackingTemplate_NotAvailable'),
      finalUrlSuffixValue: model.FinalUrlSuffixValue || i18n.get('Import_ImportOptions_TrackingTemplate_NotAvailable'),
      i18n,
      isHideUrlDetailView: false,
    }, options))
  );
}
